<template>
  <div class="pageContainer">
    <div class="topDiv backgroundCoverImageCenter">
      <h1>
        About Us
      </h1>
    </div>
    <div class="bottomDiv">
    <div class="container">
        <p>Nature has been generous with Kerala, a strip of picturesque land on the Southern Coast of India, has been under the world's magnifing glass throughout history.She drew people from all parts of the world since time immemorial. If you are ready to see the world outside your front door...grab your bag.</p>
        <p>If you are ready to see the world outside your front door...grab your bag.Nature has been generous with Kerala, a strip of picturesque land on the Southern Coast of India, has been under the world's magnifing glass throughout history.She drew people from all parts of the world since time immemorial.</p>
        <p>She drew people from all parts of the world since time immemorial.If you are ready to see the world outside your front door...grab your bag.Nature has been generous with Kerala, a strip of picturesque land on the Southern Coast of India, has been under the world's magnifing glass throughout history</p>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about' /*,
  data () {
    return {}
  } */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~scssDir/_breakpoints.scss";
@import "~scssDir/_variables.scss";
@import "~scssDir/_myAnimations.scss";
.topDiv {
  height: 60px;
  background-color: $color5;
  @include media-md{
    height:30vh;
  }
  h1 {
    line-height: 20px;
    color: $color2;
    @include media-md{
      line-height: unset;
    }
  }
}
.bottomDiv {
  height: auto;
  background-color: $color4;
  p{
    padding:10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue